import {useMemo} from 'react'

import {
  areStaffDebugCommandsEnabled,
  COLLECT_DEBUG_LOG_OPTIONS,
  STAFF_DEBUG_COMMANDS,
} from '../utils/staff-debug-commands'

/**
 * Returns staff debug commands that match the current input text as a prefix,
 * or nothing at all when the staff gate is closed.
 */
export function useStaffDebugAutocomplete(currentText: string) {
  return useMemo(() => {
    const trimmed = currentText.trimStart()
    if (!trimmed || !areStaffDebugCommandsEnabled()) return []

    if (trimmed === '/collect-debug-logs' || trimmed.startsWith('/collect-debug-logs ')) {
      return COLLECT_DEBUG_LOG_OPTIONS.filter(command => command.key.startsWith(trimmed) && command.key !== trimmed)
    }

    return STAFF_DEBUG_COMMANDS.filter(
      command =>
        command.key.startsWith(trimmed) && (command.key !== trimmed || command.appendSpace || command.argumentHint),
    )
  }, [currentText])
}

export function useStaffDebugArgumentHint(currentText: string): string | undefined {
  return useMemo(() => {
    if (!areStaffDebugCommandsEnabled()) return undefined
    return STAFF_DEBUG_COMMANDS.find(command => command.argumentHint && currentText === `${command.key} `)?.argumentHint
  }, [currentText])
}
